<template>
<section v-if="video" :class="[block.class, 'has-text-centered hero', block.mode.toLowerCase()]" :id="block.anchor ? block.anchor : ('block-' + block.id)">
    <div class="hero-body is-paddingless" v-html="video"></div>
</section>
</template>

<script>
export default {
    name: 'PageHeroVideoMode',
    props: ['block'],
    computed    :   {
        video()
        {
            if (this.block && this.block.video) {
                return this.block.video;
            }
            return null;
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/blocks/modules/herotypes/PageHeroVideoMode.vue